export const DEFAULT_COMMENTS_QUERY = {
  PageSize: 2,
  PageIndex: 0,
  ParentId: null,
};

export const COMMENT_MAX_LENGTH = 3700;
export const COMMENT_MIN_LENGTH = 2;
